import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'search',
  standalone: false
})
export class SearchPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {
  }

  transform(items: any[], search: string, key: string, key2: string = ''): any[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (search) {

      items = items.filter((item) => {
        const keysToSearch: string[] = [key, key2].filter(Boolean);

        return keysToSearch.some((k) => {
          const value = this.getNestedValue(item, k);
          const translatedValue = this.translateValue(value);

          return translatedValue?.toLowerCase()?.includes(search.toLowerCase());
        });
      });

    }

    return items;

  }


  /**
   * Función auxiliar para acceder a propiedades anidadas
   *
   */
  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, key) => {
      return current && current[key] !== undefined ? current[key] : null;
    }, obj);
  }


  /**
   * Traduce el valor si tiene formato de clave i18n
   *
   */
  private translateValue(value: any): string {
    const stringValue = value?.toString();

    if (!stringValue) {
      return '';
    }

    const isI18nKey = /^[A-Z0-9_]+(\.[A-Z0-9_]+)+$/.test(stringValue);
    return isI18nKey ? this.translate.instant(stringValue) : stringValue;
  }

}
